import RedirectUtil from '../../core/util/redirect_util';
import { ItemGroupSpecsJSOption, ItemJsEnv } from '../models/item_js_env';
import { JsEnv } from '../../core/models/js_env';
import { Item } from '../models/item';

// 念のためURLパータン(例：?baseCtgItemCd=xxx&selectGrpAttrCd=yyy)でガードする
const IS_FORCE_RESET_URL = /\?baseCtgItemCd=[^&]+&selectGrpAttrCd=.+/;

export class ItemGroupAreaAction {
  // 強制解除メッセージ
  static checkForceResetMessage(opt?: ItemGroupSpecsJSOption) {
    if (!opt?.groupAttrs?.length || !IS_FORCE_RESET_URL.test(window.location.search)) {
      return;
    }
    // 軸のコードとURLのパラメーターselectGrpAttrCdと一致するチェックし、軸名を取得
    const params = new URLSearchParams(window.location.search);
    const isGrpAttrCdChanged = params.get('grpAttrCdChanged');
    const isSellUnitChanged = params.get('sellUnitChanged');

    const diffs: string[] = [];
    if (isGrpAttrCdChanged) {
      const selectGrpAttrCdFromParam = params.get('selectGrpAttrCd');
      const changedGroupAttr = opt.groupAttrs.find(
        (attr) => attr.groupAttrCode !== selectGrpAttrCdFromParam
      );
      if (changedGroupAttr) {
        diffs.push(changedGroupAttr.groupAttrName);
      }
    }
    if (isSellUnitChanged) {
      diffs.push('販売単位');
    }
    // 強制更新メッセージ
    if (diffs.length) {
      const diffsText = diffs.join('、');
      const msg = `ご指定の組み合わせが存在しなかったので、${diffsText}が変更されました。\nあらためて組み合わせをご確認ください。`;
      alert(msg);
    }
  }

  static init(jsEnv: JsEnv) {
    const env: ItemJsEnv = new Item(jsEnv.PAGE).getModel();

    // selectタグのChangeイベントで、'data-redirect-url'に定義したURLへRedirect
    RedirectUtil.enableRedirectSelect();
    // 強制更新メッセージ提示
    ItemGroupAreaAction.checkForceResetMessage(env.itemGroupSpecsJSOption);
  }

  // JS で初期描画時に選択されているものを設定する。(ブラウザバック対策)
  static formReset() {

    const perfEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    var entryType = '';

    perfEntries.forEach((performanceNavigationTiming) => {
      // 読み込みタイプを取得
      entryType = performanceNavigationTiming.type;
    });
    if (entryType != 'back_forward') {
      return;
    }

    const selfItemElement = <HTMLFormElement>document.querySelector('[data-is-self-item="true"]');
    if (selfItemElement) {
      selfItemElement.selected = 'selected';
    }
    
  }
}
